// Module
var code = "<div class=\"content-section\"><react-component name=\"IntegrationsList\"></react-component></div>\n";
// Exports
module.exports = code;